import { Grid } from "semantic-ui-react";
import { AuditTopMenu } from "./top-menu";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ContentFilterPanel } from "../../../../components/common/content-filter";
import { AuditList } from "./list";
import { auditQueryFilterParams, ContentFilterForm } from "./content-filter";
import { determinePage } from "../../../../components/common/page-navigation";

const AuditPageComponent = () => {
  const meta = useSelector((state) => state.auditLog.meta || {});
  let [next, previous] = determinePage(meta);
  return <Page previous={previous} next={next} />;
};

const Page = ({ previous, next }) => {
  const [filterOpen, setFilterOpen] = useState(false);
  return (
    <Grid centered padded style={{ height: "100%" }}>
      <Grid.Row>
        <Grid.Column mobile={16} textAlign={"left"}>
          <AuditTopMenu
            openFilter={() => setFilterOpen(!filterOpen)}
            next={next}
            previous={previous}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ height: "inherit" }}>
        <Grid.Column mobile={16} textAlign={"left"}>
          <ContentFilterPanel
            open={filterOpen}
            onApply={() => setFilterOpen(false)}
            queryParamConfig={auditQueryFilterParams}
            FormBody={ContentFilterForm}
          >
            <AuditList />
          </ContentFilterPanel>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export const AuditPage = AuditPageComponent;
